import { createContext } from "react";

const AbsentScreen = createContext<any>(null);

export default AbsentScreen;
